import React from "react";
import { LabeledInput } from "../LabeledInput/LabeledInput";
export interface AutoFilledDateInputProps {
    label: string,
    name?: any
}

function getFormattedDate() {
    let NOW = new Date();
    let YEAR = NOW.getFullYear().toString();
    let MONTH = String(Number(NOW.getMonth().toString()) + 1); // zero indexed
    let DAY = NOW.getDate().toString();
    let HOUR = NOW.getHours().toString();
    let MINUTE = NOW.getMinutes().toString();

    MONTH = MONTH.length == 1 ? "0" + MONTH : MONTH
    DAY = DAY.length == 1 ? "0" + DAY : DAY
    HOUR = HOUR.length == 1 ? "0" + HOUR : HOUR
    MINUTE = MINUTE.length == 1 ? "0" + MINUTE : MINUTE

    return [YEAR, MONTH, DAY].join('-') + "T" + [HOUR, MINUTE].join(':');
}

const AutoFilledDateInput: React.FC<AutoFilledDateInputProps> = props => {
    return (
        <LabeledInput 
            name={props.name}
            label={props.label}
            type="datetime-local"
            value={getFormattedDate()}
        />
    )
}

export {
    AutoFilledDateInput
}
    